import React from 'react'
function CommentIcon() {
  return (
    
    <svg
  width="32px"
  height="32px"
  viewBox="0 0 24 24"
  fill="none"
  style={{ marginRight: '0.3rem' }}
  xmlns="http://www.w3.org/2000/svg"
  stroke="#ffffff"
>
  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
    <g clipPath="url(#clip0_429_11233)">
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.4876 3.36093 14.891 4 16.1272L3 21L7.8728 20C9.10904 20.6391 10.5124 21 12 21Z"
        stroke="#ffffff"
        strokeWidth="1.224"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_429_11233">
        <rect width="24" height="24" fill="white"></rect>
      </clipPath>
    </defs>
  </g>
</svg>

    
  )
}
export default CommentIcon